import React, { useEffect, useRef, useState } from "react";
import mapboxgl, { GeoJSONSource, Point } from "mapbox-gl";
import ReactDOM, { render } from "react-dom";

import "Styles/Pages/jobs.scss";
import { SendMessageForm } from "./Components/SendMessageForm";
import { EnterpriseDemoRequestMode } from "Services/API/API";

if (typeof (LiquidSpaceConfig) != "undefined" && typeof (LiquidSpaceConfig.MapboxAPIKey) != "undefined") {
   mapboxgl.accessToken = LiquidSpaceConfig.MapboxAPIKey!;
}

const messageFormRoot = document.getElementById("message-form-root")!;
render(<SendMessageForm mode={EnterpriseDemoRequestMode.CareersInline} />, messageFormRoot);

const mapRoot = document.getElementById("map-root")!;

(function () {
   const map = new mapboxgl.Map({
      container: mapRoot,
      style: "mapbox://styles/liquidspace/ckpy2c5794fsi17mvwefqxp9n",
      center: [-122.419418, 37.774929],
      zoom: 1
   });

   let hoveredStateId: string | number | undefined = 0;

   map.on("load", () => {
      map.addSource("places", {
         "type": "geojson",
         "data": {
            "type": "FeatureCollection",
            "features": [
               {
                  "type": "Feature",
                  "id": 1,
                  "properties": {
                     "description": "Perth"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [115.857048, -31.953512]
                  }
               },
               {
                  "type": "Feature",
                  "id": 2,
                  "properties": {
                     "description":
                        "Cairns"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [145.754120, -16.925491]
                  }
               },
               {
                  "type": "Feature",
                  "id": 3,
                  "properties": {
                     "description":
                        "Sydney"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [151.209290, -33.868820]
                  }
               },
               {
                  "type": "Feature",
                  "id": 4,
                  "properties": {
                     "description":
                        "Auckland"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [174.764984, -36.853611]
                  }
               },
               {
                  "type": "Feature",
                  "id": 5,
                  "properties": {
                     "description":
                        "Bangkok"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [100.501762, 13.756331]
                  }
               },
               {
                  "type": "Feature",
                  "id": 6,
                  "properties": {
                     "description":
                        "Phuket"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [98.338089, 7.951933]
                  }
               },
               {
                  "type": "Feature",
                  "id": 7,
                  "properties": {
                     "description":
                        "San Francisco"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-122.419418, 37.774929]
                  }
               },
               {
                  "type": "Feature",
                  "id": 8,
                  "properties": {
                     "description":
                        "Sun Valley"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-119.777603, 39.596371]
                  }
               },
               {
                  "type": "Feature",
                  "id": 9,
                  "properties": {
                     "description":
                        "Dallas"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-96.796989, 32.776665]
                  }
               },
               {
                  "type": "Feature",
                  "id": 10,
                  "properties": {
                     "description":
                        "Chicago"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-96.796989, 41.878113]
                  }
               },
               {
                  "type": "Feature",
                  "id": 11,
                  "properties": {
                     "description":
                        "Minneapolis"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-93.265015, 44.977753]
                  }
               },
               {
                  "type": "Feature",
                  "id": 12,
                  "properties": {
                     "description":
                        "Des Moines"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-93.624962, 41.586834]
                  }
               },
               {
                  "type": "Feature",
                  "id": 13,
                  "properties": {
                     "description":
                        "Miami"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-80.191788, 25.761681]
                  }
               },
               {
                  "type": "Feature",
                  "id": 14,
                  "properties": {
                     "description":
                        "Washington DC"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-77.036873, 38.907192]
                  }
               },
               {
                  "type": "Feature",
                  "id": 15,
                  "properties": {
                     "description":
                        "New York"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-74.005974, 40.712776]
                  }
               },
               {
                  "type": "Feature",
                  "id": 16,
                  "properties": {
                     "description":
                        "Marrakech"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-7.981084, 31.629473]
                  }
               },
               {
                  "type": "Feature",
                  "id": 17,
                  "properties": {
                     "description":
                        "Lisbon"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-9.139337, 38.722252]
                  }
               },
               {
                  "type": "Feature",
                  "id": 18,
                  "properties": {
                     "description":
                        "Madrid"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-3.703790, 40.416775]
                  }
               },
               {
                  "type": "Feature",
                  "id": 19,
                  "properties": {
                     "description":
                        "Barcelona"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [2.173404, 41.385063]
                  }
               },
               {
                  "type": "Feature",
                  "id": 20,
                  "properties": {
                     "description":
                        "London"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [-0.127758, 51.507351]
                  }
               },
               {
                  "type": "Feature",
                  "id": 21,
                  "properties": {
                     "description":
                        "Berlin"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [13.404954, 52.520008]
                  }
               },
               {
                  "type": "Feature",
                  "id": 22,
                  "properties": {
                     "description":
                        "Minsk"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [27.561523, 53.904541]
                  }
               },
               {
                  "type": "Feature",
                  "id": 23,
                  "properties": {
                     "description":
                        "Saint Petersburg"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [30.335098, 59.934280]
                  }
               },
               {
                  "type": "Feature",
                  "id": 24,
                  "properties": {
                     "description":
                        "Moscow"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [37.617298, 55.755825]
                  }
               },
               {
                  "type": "Feature",
                  "id": 25,
                  "properties": {
                     "description":
                        "Tel Aviv"
                  },
                  "geometry": {
                     "type": "Point",
                     "coordinates": [34.781769, 32.085300]
                  }
               }
            ]
         }
      });

      map.addLayer({
         "id": "places",
         "type": "circle",
         "source": "places",
         "paint": {
            "circle-radius": 4,
            "circle-stroke-width": 0,
            "circle-stroke-color": "#ffffff",
            "circle-color": [
               "case",
               ["boolean", ["feature-state", "hover"], false],
               "#00609C",
               "#00293A"
            ]
         }
      });

      const popup = new mapboxgl.Popup({
         offset: 15,
         closeButton: false,
         closeOnClick: false
      });

      map.on("mouseenter", "places", (e) => {
         if (e.features && e.features?.length > 0) {
            map.getCanvas().style.cursor = "pointer";

            if (typeof (hoveredStateId) != "undefined" && hoveredStateId != null && +hoveredStateId > 0) {
               map.setFeatureState(
                  { source: "places", id: hoveredStateId },
                  { hover: false }
               );
            }
            hoveredStateId = e.features[0].id;
            map.setFeatureState(
               { source: "places", id: hoveredStateId },
               { hover: true }
            );

            const description = e.features[0].properties?.description;
            let coordinates;

            if (e.features[0].geometry.type == "Point") {
               const p = e.features[0].geometry as GeoJSON.Point;
               if (p) {
                  coordinates = p.coordinates.slice();

                  while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                     coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                  }

                  popup.setLngLat(coordinates).setHTML(description).addTo(map);
               }
            }            
         } else {
            return;
         }
      });

      map.on("mouseleave", "places", () => {
         map.getCanvas().style.cursor = "";

         if (typeof (hoveredStateId) != "undefined" && hoveredStateId != null && +hoveredStateId > 0) {
            map.setFeatureState(
               { source: "places", id: hoveredStateId },
               { hover: false }
            );
         }
         hoveredStateId = 0;
         popup.remove();
      });
   });
})();